<template>
	<div class="loading-overlay" :class="{ 'transparent': transparent }">
		<div>
			<h2></h2>
			<div class="lds-ellipsis">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	</div>
</template>
<script>
	import { ref, computed, watch, onMounted } from "vue";
	export default {
		props: {
			transparent: {
				type: Boolean,
				default: false
			}
		},
		setup() {
			return {};
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.loading-overlay {
		@include reset-element;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 39;
		display: block;
		background-color: $color-background;

		&.transparent {
			background-color: rgba(0, 0, 0, 0);
		}

		& > div {
			display: inline-block;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -130%);
		}

		& h2 {
			display: inline-block;
			color: white;
			font-size: 3rem;
			font-weight: 500;
			filter: blur(0.4px);
		}
	}

	$scale: 2;
	$interval: 0.6s;

	.lds-ellipsis {
		display: inline-block;
		position: relative;
		width: 6.153rem * $scale;
		height: 6.153rem * $scale;
	}

	.lds-ellipsis div {
		position: absolute;
		top: 5.2rem * $scale;
		width: 1rem * $scale;
		height: 1rem * $scale;
		border-radius: 50%;
		background: $boyden-blue-light;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
	}

	.lds-ellipsis div:nth-child(1) {
		left: 0.62rem * $scale;
		animation: lds-ellipsis1 $interval infinite;
	}

	.lds-ellipsis div:nth-child(2) {
		left: 0.62rem * $scale;
		animation: lds-ellipsis2 $interval infinite;
	}

	.lds-ellipsis div:nth-child(3) {
		left: 2.46rem * $scale;
		animation: lds-ellipsis2 $interval infinite;
	}

	.lds-ellipsis div:nth-child(4) {
		left: 4.3rem * $scale;
		animation: lds-ellipsis3 $interval infinite;
	}

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}

		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}

		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}

		100% {
			transform: translate(1.85rem * $scale, 0);
		}
	}
</style>
